
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import actions from './actions';
import apis from './apis';

import uiActions from 'services/UI/actions';
import { IResponseDataBody, PaginationResponse } from 'services/response';
import { PATH_LOADING } from './constants';
import { ICategoryGiftCard, IGiftCardDetail, IGiftCardItem } from './types/giftCard';

const getGiftCardToBuy: ISagaFunc<string> = function* ({ payload }) {
  yield put(uiActions.setLoading({ path: PATH_LOADING.getGiftCardToBuy, result: true }));
  yield delay(500);
  try {
    const resData: IResponseDataBody<IGiftCardItem[]> = yield call(apis.giftCardToBuy, payload);
    if (resData?.data?.data) {
      yield put(actions.getGiftCardToBuy.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getGiftCardToBuy.fail({}));
  } finally {
    yield put(uiActions.setLoading({ path: PATH_LOADING.getGiftCardToBuy, result: false }));
  }
};

const getGiftCardDetail: ISagaFunc<{ id: string, shopId?: string | null }> = function* ({ payload }) {
  yield put(uiActions.setLoading({ path: PATH_LOADING.getGiftCardDetail, result: true }));
  yield delay(500);
  try {
    const resData: IResponseDataBody<IGiftCardDetail> = yield call(apis.getGiftCardDetail, payload.id, payload.shopId || '');
    if (resData?.data?.data) {
      yield put(actions.getGiftCardDetail.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getGiftCardDetail.fail({}));
  } finally {
    yield put(uiActions.setLoading({ path: PATH_LOADING.getGiftCardDetail, result: false }));
  }
};

const getListCategoryGiftCard: ISagaFunc<void> = function* () {
  yield put(uiActions.setLoading({ path: PATH_LOADING.getListCategoryGiftCard, result: true }));
  yield delay(500);
  try {
    const resData: IResponseDataBody<ICategoryGiftCard[]> = yield call(apis.getListCategoryGiftCard);
    if (resData?.data?.data) {
      yield put(actions.getListCategoryGiftCard.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListCategoryGiftCard.fail({}));
  } finally {
    yield put(uiActions.setLoading({ path: PATH_LOADING.getListCategoryGiftCard, result: false }));
  }
};

const getListGiftCardByCategory: ISagaFunc<{ page: number, size: number, category: string }> = function* ({ payload }) {
  yield put(uiActions.setLoading({ path: PATH_LOADING.getListGiftCardByCategory, result: true }));
  yield delay(500);
  try {
    const resData: IResponseDataBody<PaginationResponse<IGiftCardItem>>= yield call(apis.getListGiftCardByCategory, payload.page, payload.size, payload.category);

    if (resData?.data?.data) {
      yield put(actions.getListGiftCardByCategory.success({
        data: resData.data.data.content,
        hasMore: resData.data.data.content.length === payload.size,
        page: resData.data.data.pageable.pageNumber + 1,
        append: payload.page > 1,
        totalPages: resData.data.data.totalPages,
      }));
    }
  } catch (error) {
    yield put(actions.getListGiftCardByCategory.fail({}));
  } finally {
    yield put(uiActions.setLoading({ path: PATH_LOADING.getListGiftCardByCategory, result: false }));
  }
};

export default function* giftCardServiceSagas() {
  yield takeLatest(actions.getGiftCardToBuy.fetch, getGiftCardToBuy);
  yield takeLatest(actions.getGiftCardDetail.fetch, getGiftCardDetail);
  yield takeLatest(actions.getListCategoryGiftCard.fetch, getListCategoryGiftCard);
  yield takeLatest(actions.getListGiftCardByCategory.fetch, getListGiftCardByCategory);
}
